import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
    {
        id: "po-07-h6v1-01",
        name: "PO 01 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
        size: [1190, 850],
        style: {},
        slots: [       
            { id: "1", x: 43, y: 237, width: 263, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 430, width: 263, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 314, y: 237, width: 240, height: 377, rotation: 0, imageRotation: 0 },
            { id: "4", x: 638, y: 237, width: 252, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 638, y: 430, width: 252, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 898, y: 237, width: 251, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 898, y: 430, width: 251, height: 184, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-02",
        name: "PO 02 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 46, y: 160, width: 503, height: 348, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 46, y: 515, width: 248, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 515, width: 247, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 637, y: 160, width: 209, height: 172, rotation: 0, imageRotation: 0 },
            { id: "5", x: 637, y: 340, width: 209, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 637, y: 519, width: 209, height: 171, rotation: 0, imageRotation: 0 },
            { id: "7", x: 854, y: 160, width: 289, height: 529, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-03",
        name: "PO 03 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 48, y: 182, width: 503, height: 353, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 48, y: 542, width: 163, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 219, y: 542, width: 162, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 389, y: 542, width: 162, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 638, y: 130, width: 503, height: 341, rotation: 0, imageRotation: 0 },
            { id: "6", x: 638, y: 479, width: 338, height: 241, rotation: 0, imageRotation: 0 },
            { id: "7", x: 984, y: 479, width: 157, height: 241, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-04",
        name: "PO 04 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 44, y: 124, width: 251, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 328, width: 251, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 44, y: 532, width: 251, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 303, y: 124, width: 250, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 303, y: 328, width: 250, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 303, y: 532, width: 250, height: 196, rotation: 0, imageRotation: 0 },
            { id: "7", x: 700, y: 124, width: 385, height: 604, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-05",
        name: "PO 05 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 56, y: 219, width: 264, height: 203, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 430, width: 264, height: 202, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 219, width: 263, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 328, y: 430, width: 263, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 599, y: 219, width: 264, height: 413, rotation: 0, imageRotation: 0 },
            { id: "6", x: 871, y: 219, width: 263, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 871, y: 430, width: 263, height: 202, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-06",
        name: "PO 06 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 90, y: 111, width: 408, height: 310, rotation: 0, imageRotation: 0 },
            { id: "2", x: 90, y: 429, width: 408, height: 310, rotation: 0, imageRotation: 0 },
            { id: "3", x: 506, y: 111, width: 376, height: 628, rotation: 0, imageRotation: 0 },
            { id: "4", x: 890, y: 111, width: 210, height: 151, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 270, width: 210, height: 151, rotation: 0, imageRotation: 0 },
            { id: "6", x: 890, y: 429, width: 210, height: 151, rotation: 0, imageRotation: 0 },
            { id: "7", x: 890, y: 588, width: 210, height: 151, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-07",
        name: "PO 07 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 43, y: 130, width: 258, height: 192, rotation: 0, imageRotation: 0 },
            { id: "2", x: 43, y: 330, width: 258, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 43, y: 529, width: 258, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 308, y: 130, width: 336, height: 590, rotation: 0, imageRotation: 0 },
            { id: "5", x: 652, y: 130, width: 493, height: 384, rotation: 0, imageRotation: 0 },
            { id: "6", x: 652, y: 523, width: 243, height: 198, rotation: 0, imageRotation: 0 },
            { id: "7", x: 903, y: 523, width: 243, height: 198, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "po-07-h6v1-08",
        name: "PO 08 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 65, y: 165, width: 321, height: 520, rotation: 0, imageRotation: 0 },
            { id: "2", x: 393, y: 165, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 393, y: 341, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 393, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 640, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 517, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 640, y: 165, width: 485, height: 344, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-09",
        name: "PO 09 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 65, y: 165, width: 321, height: 520, rotation: 0, imageRotation: 0 },
            { id: "2", x: 393, y: 165, width: 486, height: 344, rotation: 0, imageRotation: 0 },
            { id: "3", x: 393, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 640, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 887, y: 165, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 341, width: 238, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 887, y: 517, width: 238, height: 168, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-07-h6v1-10",
        name: "PO 10 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 65, y: 165, width: 487, height: 344, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 65, y: 517, width: 240, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 313, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 559, y: 165, width: 321, height: 520, rotation: 0, imageRotation: 0 },
            { id: "5", x: 888, y: 165, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 888, y: 341, width: 239, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 888, y: 517, width: 239, height: 168, rotation: 0, imageRotation: 0 }
        ],
    }
];